export default __webpack_public_path__ + "static/media/orden-busqueda.ab5dee45.svg";